import React, { createContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "@frontegg/react";
import useAppStore from "src/stores/appStore";

const SocketContext = createContext(null);
const SERVER_DISCONNECT = "io server disconnect";
const AUTH_ERROR_CODE = "AUTH_FAILED";

const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { user } = useAuth();
  const accessToken = user?.accessToken;
  useEffect(() => {
    if (!accessToken) {
      setSocket(null);
      return () => {};
    }

    useAppStore.getState().setAccessToken(accessToken);

    const serverUrl = import.meta.env.VITE_DASHBOARD_API_URL;
    const options = {
      auth: (cb) => cb({ token: useAppStore.getState().accessToken }),
      transports: ["websocket"]
    };

    const newSocket = io(serverUrl, options);
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
      setSocket(null);
    };
  }, [accessToken]);

  useEffect(() => {
    if (!socket) return;

    let authFailed = false;

    const handleServerError = (error) => {
      if (error?.code === AUTH_ERROR_CODE) {
        authFailed = true;
      }
    };

    const handleDisconnect = (reason) => {
      if (!authFailed && reason === SERVER_DISCONNECT) {
        socket.connect();
      }
    };

    socket.on("error", handleServerError);
    socket.on("disconnect", handleDisconnect);
    return () => {
      socket.off("error", handleServerError);
      socket.off("disconnect", handleDisconnect);
    };
  }, [socket]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export { SocketProvider, SocketContext };
